<template>
  <div>
    <breadcrumb :routerList="[{to:'/credit',title:'经理销售维度'},{title:'客户详情'}]" />
    <div class="h-content">
		<div class="h-pieceIn2 icon">
		    <div class="h-pieceCon2" style="width:100%;padding:20px 10px;border:1px solid #d7e0f1;background-color: white;margin-bottom: 30px;">
		        <div class="stepBox">
		            <div class="leftstep">销售经理</div>
		            <div class="rightstep">
		                <div class="readiu">
		                    <img src="../../../assets/images/checksuccess.png" alt="" style="" />
		                </div>
		            </div>
		            <div class="leftstep">区域经理</div>
		            <div class="fukaun">
		                <div class="color">
		                    <!-- <img src="../../../assets/images/checksuccess.png" alt="" class="bac-color">                             -->
		                </div>
		            </div>
		            <div class="fuwu">客户主管</div>
		            <div class="fukaun">
		                <div class="color">
		                    <!-- <img src="../../../assets/images/checksuccess.png" alt="" > -->
		                </div>
		            </div>
		           
		            <div class="fuwu">财务经理</div>
		        </div>
		    </div>
		</div>
		<div class="h-row h-mrt0" style="margin:0 -0.12rem ;">
			<div class="h-rowIn">
				<div class="h-rowBox">
					<el-form :model="zy" label-position="right" ref="zy" :rules="rules" :inline="true" class="demo-ruleForm h-formbLine h-formbLine1">
					<div class="h-rowCon">
						<div class="h-pieceIn2">
		                    <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
							<div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
								<h1>信贷信息</h1>
							</div>
							
							<div class="h-pieceCon2">
								<div class="h-formLine weekplandetail25">
								   <el-form-item label="客户名称" class="h-elformWrap-2">
										<el-input placeholder="请输入" v-model="zy.khmc" disabled></el-input>
								   </el-form-item>
								   <el-form-item label="申请金额" class="h-elformWrap-2" >
										<el-input placeholder="请输入" v-model="zy.sqje" disabled></el-input>
								   </el-form-item>
								   <el-form-item label="承诺回款时间" class="h-elformWrap-2">
										<el-input placeholder="请输入" v-model="zy.cnhksj" disabled></el-input>
								   </el-form-item>
								   <el-form-item label="有签字/逾期" class="h-elformWrap-2" >
										<el-input placeholder="请输入" v-model="zy.qianzi" disabled></el-input>
								   </el-form-item>
								   <el-form-item label="签字单位" class="h-elformWrap-2" >
								   		<el-input placeholder="请输入" v-model="zy.qzdw" disabled></el-input>
								   </el-form-item>
								   <el-form-item label="申报时间" class="h-elformWrap-2" >
								   		<el-input placeholder="请输入" v-model="zy.sbsj" disabled></el-input>
								   </el-form-item>
								   <el-form-item label="批复账期" class="h-elformWrap-2" >
								   		<el-input placeholder="请输入" v-model="zy.pfzq" disabled></el-input>
								   </el-form-item>
								   <el-form-item label="批复凭证" class="h-elformWrap-2" >
								   		<el-input placeholder="请输入" v-model="zy.pfpz" disabled></el-input>
								   </el-form-item>
		                           <el-form-item label="凭证图片" class="h-elformWrap-2 extraItem"  style="width:100%!important;">
		                           		<div class="conimgList">
											<div class="ConImg">
												<div class="circleBages">1</div>
												<img width="100%" src="../../../assets/images/h-dialogImg2.png" alt="">
											</div>
										</div>
		                           		  
		                           </el-form-item>
								</div>
							</div>
						</div>
		               
					</div>
					</el-form>
				</div>
			</div>
		</div>
      
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
		tabIndex:1,
		isshow:true,
		zy: {
			khmc:'',
			sqje:'',
			cnhksj:'',
			qianzi:'',
			qzdw:'',
			sbsj:'',
			pfzq:'',
			pfpz:''
		},
      //表单
      q: {
          cdateBegin: null,
          cdateEnd: null,
          pageSize: 10,
          pageNo: 1,
          total:0,
      },
      //表格
      multipleSelection: [],
	  options1:[
		  {value:1,label:'有签字'},
		  {value:2,label:'逾期'},
	  ]
	 
    };
  },
  created() {

  },
  methods: {
	  tabchange(i){
		  this.tabIndex = i;
	  },

  },
  mounted() {

  }
};
</script>
<style scoped="scoped" lang="scss">
	.conimgList{
		display: flex;
		width: 100%;
		.ConImg{
			width: 99px;
			height: 99px;
			border: 1px solid #f2f2f2;
			margin-right: 10px;
			position: relative;
			.circleBages {
				width: 25px;
				height: 25px;
				border-radius: 50%;
				background-color: #16b220;
				color: white;
				text-align: center;
				line-height: 25px;
				font-size: 10px;
				position: absolute;
				right: 0;
				top: 0;
			}
			img{
				height: 100%;
				width: 100%;
				margin-right: 10px;
			}
		}
	}
	.outerCon{
		display: flex;
		justify-content: flex-start;
		border-bottom:1px solid #dae0f0;
		width: 100%;
		margin-bottom: 30px;
		.tabBtn{
			background-color: #f0f5fb;
			padding: 10px;
			border: 1px solid #dae0f0;
			margin-right: 10px;
			color: #282c2f;
			cursor: pointer;
		}
		.tabBtnAc{
			color: white;
			background-color: #2785e7;
		}
	}
	
	/*--------------- 审批样式 ------------------*/
	
	.rightstep {
	    width: 170px;
	    height: 5px;
	    background-image: linear-gradient(-90deg,
	    #0056a4 0%,
	    #3291fd 100%),
	    linear-gradient(
	            #0e75e9,
	            #0e75e9);
	    background-blend-mode: normal,
	    normal;
	    position: relative;
	}
	
	.readiu {
	    border-radius: 50%;
	    width: 30px;
	    height: 30px;
	    border: 3px solid #0056a4;
	    position: relative;
	    left: 74px;
	    top: -12px;
	    background-color: white;
	}
	
	.fukaun {
	    width: 170px;
	    height: 5px;
	    background-image: linear-gradient(-90deg,
	    #e2e5e7 0%,
	    #e2e5e7 100%),
	    linear-gradient(
	            #e2e5e7,
	            #e2e5e7);
	    background-blend-mode: normal,
	    normal;
	    position: relative;
	}
	
	.color {
	    border-radius: 50%;
	    width: 30px;
	    height: 30px;
	    border: 3px solid #c7c8ca;
	    position: relative;
	    left: 74px;
	    top: -12px;
	    background-color: white;
	}
	
	.fuwu {
	    width: 48px;
	    height: 50px;
	    background-color: white;
	    border-radius: 4px;
	    border: solid 2px #c7c8ca;
	    font-size: 15px;
	
	    text-align: center;
	    /* padding: 16px 0; */
	    position: relative;
	    flex-shrink: 0;
	    margin: 20px 0;
	}
	
	.stepBox {
	    width: 100%;
	    display: flex;
	    flex-wrap: wrap;
	    justify-content: flex-start;
	    align-items: center;
	    margin-left: 3%;
	}
	
	.leftstep {
	    width: 48px;
	    height: 50px;
	    background-color: #fcfcfc;
	    border-radius: 4px;
	    border: solid 2px #0e75e9;
	    font-size: 15px;
	    color: #0e75e9;
	    text-align: center;
	    /* padding: 16px 0; */
	    position: relative;
	    flex-shrink: 0;
	    margin: 20px 0;
	
	}
	
	img {
	    width: 18px;
	    padding: 3px 0;
	    margin-left: 0.035rem;
	    /* margin-top: -3px; */
	    color: block;
	}
	
	.name {
	    margin-left: 9px;
	    /* margin-top: -24px; */
	}
	
	.fanhui {
	    padding: 15px 35px;
	    color: white;
	    background-color: #006aca;
	}
	
	.F-H {
	    margin-top: 15px;
	    margin-left: 8rem;
	}
	
	.stepBox {
	    width: 100%;
	    display: flex;
	    flex-wrap: wrap;
	    justify-content: flex-start;
	    align-items: center;
	    margin-left: 3%;
	}
	
	.stepBox .step {
	    width: 16%;
	    display: flex;
	    justify-content: flex-start;
	    align-items: center;
	}
	
	.stepBox .step:last-child {
	    width: 100px;
	}
	
	.stepBox .step .leftstep {
	    width: 48px;
	    height: 50px;
	    background-color: #fcfcfc;
	    border-radius: 4px;
	    border: solid 2px #0e75e9;
	    font-size: 15px;
	    color: #0e75e9;
	    text-align: center;
	    /* padding: 16px 0; */
	    position: relative;
	    flex-shrink: 0;
	    margin: 20px 0;
	
	}
	
	.stepBox .step .leftstep .times {
	    width: 140px;
	    position: absolute;
	    top: 120px;
	
	    display: flex;
	    flex-direction: column;
	    justify-content: center;
	    align-items: center;
	    font-size: 14px;
	    color: #595959;
	}
	
	.stepBox .step .rightstep {
	    width: 170px;
	    height: 5px;
	    background-image: linear-gradient(-90deg,
	    #0056a4 0%,
	    #3291fd 100%),
	    linear-gradient(
	            #0e75e9,
	            #0e75e9);
	    background-blend-mode: normal,
	    normal;
	    position: relative;
	}
	
	.stepBox .step .rightstep .circle {
	    width: 23px;
	    height: 23px;
	    background-color: #fcfcfc;
	    border: 2px solid #3291fd;
	    overflow: hidden;
	    border-radius: 50%;
	    position: absolute;
	    top: -9px;
	    left: 63%;
	    transform: translateX(-25px);
	}
	
	.stepBox .step .rightstep .circle img {
	    position: absolute;
	    top: 0;
	    left: 0;
	    right: 0;
	    bottom: 0;
	    margin: auto;
	    width: 15px;
	}
	
	.make {
	    width: 110px;
	    padding-left: 17px;
	}
	
	.jiazhi {
	    width: 100px;
	    padding-left: 20px;
	}
	
	.zhangqi {
	    width: 168px;
	    padding-left: 10px;
	}
	
	.yuan, .zhanyong, .money, .xianjin, .dingdan {
	    width: 120px;
	    padding-left: 20px;
	}
	
	
	.renminbi {
	    width: 90px;
	    padding-left: 20px;
	}
	
	.bizhong {
	    width: 72px;
	    padding-left: 20px;
	
	}
	
	.renminbi,
	.money,
	.yuan,
	.zhangqi,
	.make {
	    background-color: white;
	    font-size: 10px;
	}
	
	.bizhong,
	.dingdan,
	.xianjin,
	.zhanyong,
	.jiazhi {
	    background-color: #ebf5ff;
	    font-size: 10px;
	}
	
	.bizhong,
	.renminbi,
	.dingdan,
	.money,
	.xianjin,
	.yuan,
	.zhangqi,
	.zhanyong,
	.jiazhi,
	.make {
	    font-size: 15px;
	    color: black;
	    padding: 20px 0;
	    padding-left: 18px;
	    border-bottom: 1px solid rgb(223, 222, 222);
	    border-right: 1px solid rgb(236, 236, 236);
	}
	
	.jieguo {
	    margin-top: 12px;
	    display: flex;
	    margin: 0 20px;
	
	}
	
	/*span {*/
	/*    color: white;*/
	/*    position: relative;*/
	/*    top: -12px;*/
	/*    left: 20px;*/
	/*    font-size: 14px;*/
	/*}*/
	

	
	.newProject {
	    margin: 0 20px;
	    background-color: rgb(94, 182, 233);
	}
	
	.h-crumbOut {
	    margin-bottom: 20px;
	}
	
	.h-piece {
	    margin: 20px;
	}
	
	.h1 {
	    margin-left: 27px;
	}
	
	.bbbb {
	    padding-top: 5px;
	    margin: 10px 20px 0 20px;
	}
	
	.neixiao .h-formbLine .h-elformWrap-2 {
	    width: 33.333%;
	}
	
	.hang {
	    padding: 20px 0;
	    margin-bottom: 0;
	    background-color: white;
	}
</style>
<style>
 .h-formbLine .el-form-item__label{
	width: 31%;
	text-align: right;
}
.h-formbLine .extraItem  .el-form-item__label{
	width: 9.7%;
	text-align: right;
}
 .h-formbLine .el-form-item__content{
	width: 69%;
}
.h-formbLine .h-elformWrap-2{
	width: 33.333%!important;
	padding-right: 0.5rem
}
 .h-formbLine .h-elformWrap-1{
	width: 100%;
	padding-right: 0.5rem
}
 .h-formbLine .h-elformWrap-1 .el-form-item__label{
	width: 9.7%;
}
.weekplandetail25 .h-formbLine .h-elformWrap-1 .el-form-item__content{
	width: 90.3%;
}
</style>
